import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackCopiedFilePath.meta';

export type UseTrackCopiedFilePathParams = {
  location: 'asset-details' | 'asset-modal-header' | 'board-header-menu' | 'board-breadcrumb';
};

export const useTrackCopiedFilePath = () => {
  const { track } = useAnalyticsUtilities();

  const trackCopiedFilePath = useCallback(
    (params: UseTrackCopiedFilePathParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackCopiedFilePath };
};
